module.exports = __webpack_public_path__ + "static/media/bkash-payment-wv.b52dd4ab.svg";